/** PINs are strings: a leading zero is significant. */
export function isValidPin(pin) {
    if (typeof pin !== "string" || !/^[0-9]{5}$/.test(pin)) return false;
    if (/^(\d)\1{4}$/.test(pin)) return false;
    if (/^(\d)(\d)\1\2\1$/.test(pin) || /(\d)\1{2}/.test(pin) || /(\d)\1(\d)\2/.test(pin)) return false;
    const digits = [...pin].map(Number);
    const ascending = digits.slice(1).every((digit, index) => digit === (digits[index] + 1) % 10);
    const descending = digits.slice(1).every((digit, index) => digit === (digits[index] + 9) % 10);
    const stepTwo = digits.slice(1).every((digit, index) => digit === (digits[index] + 2) % 10);
    const stepMinusTwo = digits.slice(1).every((digit, index) => digit === (digits[index] + 8) % 10);
    return !ascending && !descending && !stepTwo && !stepMinusTwo;
}

/** Unlocking existing credentials checks the format only. */
export function getPinValidationError(pin, checkStrength = true) {
    if (typeof pin !== "string" || !/^[0-9]{5}$/.test(pin)) return "pinLength";
    if (checkStrength && !isValidPin(pin)) return "weakPin";
    return "";
}
